import { useState } from 'react'
import { useCart } from '../../../cart'
import { purchasabilityMessageByReason, resolveCatalogProductPurchasability } from '../../purchasability'
import type { CatalogProduct } from '../../types'

export const useSearchResultsCartFeedback = ({ language }: { language: 'it' | 'en' }) => {
  const { addItem, busy: cartBusy } = useCart()
  const [cartFeedback, setCartFeedback] = useState('')

  const handleAddToCart = async (product: CatalogProduct) => {
    const purchasability = resolveCatalogProductPurchasability(product)
    if (!product._id) {
      setCartFeedback(language === 'en' ? 'Product unavailable' : 'Prodotto non disponibile')
      return
    }
    if (!purchasability.isPurchasable) {
      const reason = purchasability.reason
      setCartFeedback(
        reason
          ? purchasabilityMessageByReason[reason]
          : language === 'en'
          ? 'Product cannot be purchased'
          : 'Prodotto non acquistabile',
      )
      return
    }

    const ok = await addItem(product._id, 1)
    setCartFeedback(
      ok
        ? language === 'en'
          ? `${product.name} added to cart`
          : `${product.name} aggiunto al carrello`
        : language === 'en'
        ? 'Unable to add product to cart'
        : 'Impossibile aggiungere al carrello',
    )
  }

  return { cartBusy, cartFeedback, handleAddToCart }
}
